<div [ngClass]="buttonGroupClass()">
    <ng-content></ng-content>
</div>